import styled from "styled-components";

import { FlexRow } from "@similarweb/ui-components";

export const StyledQuickActionsContainer = styled(FlexRow)`
    gap: 16px;
`;
